var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketStarOrange(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1626 3.33325H5.82923C2.63756 3.33325 1.7459 4.09992 1.6709 7.08325C3.27923 7.08325 4.57923 8.39159 4.57923 9.99992C4.57923 11.6083 3.27923 12.9083 1.6709 12.9166C1.7459 15.8999 2.63756 16.6666 5.82923 16.6666H14.1626C17.4959 16.6666 18.3292 15.8333 18.3292 12.4999V7.49992C18.3292 4.16659 17.4959 3.33325 14.1626 3.33325Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49438 3.33325V6.24992",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49438 13.75V16.6667",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5208 7.77505L13.0374 8.81672C13.0874 8.91672 13.1874 8.99172 13.2958 9.00838L14.4458 9.17505C14.7291 9.21672 14.8458 9.56672 14.6374 9.76672L13.8041 10.575C13.7208 10.65 13.6874 10.7667 13.7041 10.8834L13.9041 12.025C13.9541 12.3084 13.6541 12.525 13.4041 12.3917L12.3791 11.85C12.2791 11.8 12.1541 11.8 12.0541 11.85L11.0291 12.3917C10.7708 12.525 10.4791 12.3084 10.5291 12.025L10.7291 10.8834C10.7458 10.7667 10.7124 10.6584 10.6291 10.575L9.8041 9.76672C9.59577 9.56672 9.71243 9.21672 9.99577 9.17505L11.1458 9.00838C11.2624 8.99172 11.3541 8.92505 11.4041 8.81672L11.9124 7.77505C12.0291 7.51672 12.3958 7.51672 12.5208 7.77505Z",
    stroke: "#EC421C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketStarOrange);
export default __webpack_public_path__ + "static/media/ticket-star-orange.4b2782c5c35ef61f2ebefde46fbc27f9.svg";
export { ForwardRef as ReactComponent };